import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notificationController } from 'infrastructure/antd/controllers/notification-controller';
import { useTranslation } from 'react-i18next';
import dataService, { type IResponse } from 'services/dataService';
import { apiCompleteTask } from 'services/dataService/resources/oneplatform/api';

import { getTasksByPatientQueryKey } from './use-get-tasks-by-patient';

import type { ITaskCard } from '../types';

export const useCompleteTask = (patientGuid: string) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: (taskGuid: string) =>
      dataService.createOne<{ task: ITaskCard }>(apiCompleteTask(taskGuid), {}),
    onSuccess: (response: IResponse<{ task: ITaskCard }>) => {
      if (response.error) {
        notificationController.error({
          message: t('tasksDrawer.completeError'),
        });
        if (response.status === 409) {
          queryClient.invalidateQueries(getTasksByPatientQueryKey(patientGuid));
        }
        return;
      }

      notificationController.success({
        message: t('tasksDrawer.completeSuccess'),
      });
      queryClient.invalidateQueries(getTasksByPatientQueryKey(patientGuid));
    },
  });
};
